// extracted by mini-css-extract-plugin
export default {"container":"LanguageSelect_container__FME-j","selectedLang":"LanguageSelect_selectedLang__uZw5J","langItem":"LanguageSelect_langItem__QyU+1","flag":"LanguageSelect_flag__fx0kL"};